import { render, staticRenderFns } from "./FormCheckboxStackedInline.vue?vue&type=template&id=64e4cdc6"
import script from "./FormCheckboxStackedInline.vue?vue&type=script&lang=js"
export * from "./FormCheckboxStackedInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports